import React from "react";
import Grid from "@mui/material/Grid2";
import { styled } from "@mui/material/styles";
import Typography from "@mui/material/Typography";
import eleTech from "../../assets/images/ele_techlog.png";
import etlBg from "../../assets/images/etl_bg.png";

const PREFIX = "TechLogBookFeatures";

const classes = {
  elTechImg: `${PREFIX}-elTechImg`,
  contentBox: `${PREFIX}-contentBox`,
  wrapper: `${PREFIX}-wrapper`,
  techLogTitle: `${PREFIX}-techLogTitle`,
  techlogContent: `${PREFIX}-techlogContent`,
};

const StyledGrid = styled(Grid)(({ theme }) => ({
  [`& .${classes.techLogTitle}`]: {
    color: "white",
    fontFamily: "AvenirLTStd-Roman",
    marginBottom: "3%",
    textAlign: "left",
    letterSpacing: "0.66px",
    fontSize: 30,
    [theme.breakpoints.down("sm")]: {
      fontSize: "20px",
      fontWeight: "500",
      marginTop: "8%",
      marginBottom: '10%' 
    },
  },
  [`& .${classes.techlogContent}`]: {
    padding: "1em 1em 1em 0.5em",
    fontSize: 20,
    fontWeight: 100,
    width: "90%",
    color: "white",
    textAlign: "left",
    fontFamily: "AvenirLTStd-Book",
    [theme.breakpoints.down("sm")]: {
      width: "100%",
      padding: 0,
      marginTop: "1em",
      fontSize: 16,
      textAlign: "left",
    },
    [theme.breakpoints.between("sm", "md")]: {
      padding: "2em 1em 1em 1em",
      fontSize: 25,
      textAlign: "left",
    },
    [theme.breakpoints.up("md")]: {
      fontSize: 25,
      textAlign: "left",
      marginBottom: "3%",
    },
    [theme.breakpoints.up("md")]: {},
  },
  [`&.${classes.wrapper}`]: {
    backgroundImage: `url(${etlBg})`,
    backgroundSize: "cover",
    backgroundPosition: "center",
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
    padding: theme.spacing(4),
  },
  [`& .${classes.elTechImg}`]: {
    width: "100%",
    maxWidth: "350px",
    height: "260px",
    objectFit: "cover",
    borderRadius: "30px",
    border: "2px solid black",
    backgroundColor: "white",
    display: "block",
    margin: "0 auto",
    padding: theme.spacing(2),
    boxSizing: "border-box",
    [theme.breakpoints.down("sm")]: {
      maxWidth: "250px", 
      height: "180px", 
    },
  },
  [`& .${classes.contentBox}`]: {
    textAlign: "center",
    [theme.breakpoints.up("md")]: {
      textAlign: "left",
      paddingLeft: theme.spacing(4),
    },
  },
}));

const TechLogBookFeatures = () => {
  return (
    <StyledGrid container className={classes.wrapper}>
      <Grid size={{ xs: 12 }}>
        <Grid
          container
          alignItems="center"
          justifyContent="center"
          sx={{ display: "flex" }}
        >
          <Grid size={{ xs: 12, md: 4 }}>
            <img
              alt="Electronic Tech Log"
              className={classes.elTechImg}
              src={eleTech}
            />
          </Grid>
          <Grid size={{ xs: 12, md: 8 }}>
            <div className={classes.contentBox}>
              <Typography className={classes.techLogTitle} variant="h1" gutterBottom>
                Streamline Your Maintenance With Our Electronic Tech Log
              </Typography>
              <Typography variant="body2" className={classes.techlogContent} gutterBottom>
                Our Modular Electronic Technical Logbook replaces paper with
                real-time, error-free data management.
              </Typography>
              <Typography variant="body2" className={classes.techlogContent} gutterBottom>
                More than a paper substitute, it's a mission-critical tool that
                enhances efficiency, saving time and resources across your
                operation.
              </Typography>
              <Grid sx={{ borderBottom: "1px solid white", width: "50%", marginTop: "1%" }}></Grid>
            </div>
          </Grid>
        </Grid>
      </Grid>
    </StyledGrid>
  );
};

export default TechLogBookFeatures;
